import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const links = [
  { label: "Work", href: "#work" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
];

const CV_HREF = "/wotobe-koffi-roland-cv.pdf";

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="site-nav"
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, delay: 1.4, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-[#F9F9F7]/85 backdrop-blur-md border-b border-[#E5E5DF]" : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 h-16 md:h-20 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="font-mono text-xs tracking-[0.2em] uppercase">
          WKR<span className="text-[#5C5C5C]">.</span>
        </a>
        <nav className="flex items-center gap-5 md:gap-8">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-mono text-[0.7rem] uppercase tracking-[0.18em] text-[#0A0A0A] relative group"
            >
              {l.label}
              <span className="absolute left-0 -bottom-1 h-px w-0 bg-[#0A0A0A] transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
          <a
            href={CV_HREF}
            download
            data-testid="nav-cv"
            className="group inline-flex items-center gap-2 border border-[#0A0A0A] px-3 py-2 font-mono text-[0.65rem] uppercase tracking-[0.18em] text-[#0A0A0A] transition-colors duration-300 hover:bg-[#0A0A0A] hover:text-[#F9F9F7]"
          >
            CV
            <span className="transition-transform duration-300 group-hover:translate-y-0.5">↓</span>
          </a>
        </nav>
      </div>
    </motion.header>
  );
};

export default Nav;
